import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';

export const flowExecutionIdSelector = createSelector(
  (state: StoreType) => state.flowTrack.flowExecutionId,
  (serverFlowExecutionId) => serverFlowExecutionId
);
